module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/a314b6745357bba80e03ea7e9856693e.svg";